(async () => {
    const { Core } = await importModule('Core');

    const CN_LOADING = '!loading';
    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_BELONGS_FORM = 'form-child';
    
    customElements.define('product-to-cart', class extends Core {
        elements = {
            button: '[data-to-cart]'
        }
        
        subscriptions = {
            'cart:update':  '_cartUpdateHandler',
            'cart:error':  '_cartUpdateHandler'
        }

        render() {
            this.subscribe('cart:update', { global: true });
            this.subscribe('cart:error', { global: true });
            this._handleClick()
        }

        _handleClick() {
            this.addEventListener('click', this._onClick.bind(this))
        }

        _onClick() {
            this.loading = true;
            !this.belongsToForm && this.addToCart(this.cartItem);
        }
 
        addToCart(items) {
            var now = new Date();
			var vendor_popup_expiry = localStorage.getItem("vendor_popup_expiry");
            if(vendor_popup_expiry != "" && vendor_popup_expiry != null){
              if (now.getTime() > vendor_popup_expiry) {				
					localStorage.removeItem("vendor_popup_expiry")
					var popUpSHouldOpen = true;
				}else{
                 var popUpSHouldOpen = false;
                }
            }else{
              var popUpSHouldOpen = true;
            }


            if((this.getAttribute("product-vendor") == "BioCeuticals") && popUpSHouldOpen){
              this.publish('modal:open', {
                target: '#surveyPopupTemplate',
                backdrop: true,
                close: false,
                animation: 'fade',
                transition: 500,
                position: "center",
                productTitle: this.getAttribute("product-title")
            });
            this.loading = false;  
            window.localStorage.setItem("specificProducts",JSON.stringify(items));
            setTimeout(() => {
            var questionItemBoxes = document.querySelectorAll(".survey-modal .question_item--checkbox--wrapper");
            questionItemBoxes.forEach(function(questionItemBox){
              var checkBoxes = questionItemBox.querySelectorAll("input[type=checkbox]");
              checkBoxes.forEach(function(checkBox){
                checkBox.addEventListener("change", function(){
                  var closestQuestionItemBox = checkBox.closest(".question_item--checkbox--wrapper");
                  var foundChecked = false;
                  closestQuestionItemBox.querySelectorAll("input[type=checkbox]").forEach(function(item){
                   if(item.checked == true){
                     foundChecked = true;
                   }
                  });
                  if(foundChecked == true){
                     closestQuestionItemBox.querySelectorAll("input[type=checkbox]").forEach(function(item){
                      item.removeAttribute("required");
                     });
                  }else{
                    closestQuestionItemBox.querySelectorAll("input[type=checkbox]").forEach(function(item){
                      item.setAttribute("required","");
                     });
                  }
                });
              });
            });
          },2000);  
            }else if((this.getAttribute("product-survey_popup2-show") == "true") && popUpSHouldOpen){
              this.publish('modal:open', {
                    target: '#surveyPopupTemplate2',
                    backdrop: true,
                    close: false,
                    animation: 'fade',
                    transition: 500,
                    position: "center",
                    productTitle: this.getAttribute("product-title")
                });
                this.loading = false;  
                window.localStorage.setItem("specificProducts",JSON.stringify(items));
                setTimeout(() => {
                var questionItemBoxes = document.querySelectorAll(".survey-modal .question_item--checkbox--wrapper");
                questionItemBoxes.forEach(function(questionItemBox){
                  var checkBoxes = questionItemBox.querySelectorAll("input[type=checkbox]");
                  checkBoxes.forEach(function(checkBox){
                    checkBox.addEventListener("change", function(){
                      var closestQuestionItemBox = checkBox.closest(".question_item--checkbox--wrapper");
                      var foundChecked = false;
                      closestQuestionItemBox.querySelectorAll("input[type=checkbox]").forEach(function(item){
                      if(item.checked == true){
                        foundChecked = true;
                      }
                      });
                      if(foundChecked == true){
                        closestQuestionItemBox.querySelectorAll("input[type=checkbox]").forEach(function(item){
                          item.removeAttribute("required");
                        });
                      }else{
                        closestQuestionItemBox.querySelectorAll("input[type=checkbox]").forEach(function(item){
                          item.setAttribute("required","");
                        });
                      }
                    });
                  });
                });
              },2000);  


            }
            else{
              this.publish('cart:add', {
                items
            });
            }
            
        }

        _cartUpdateHandler() {
            setTimeout(() => {
                this.loading = false
            }, 1500)
        }

        get belongsToForm() {
            return this.hasAttribute(ATTR_BELONGS_FORM)
        }

        get cartItem() {
            return [{ 
                id: +this.getAttribute(ATTR_VARIANT_ID), 
                quantity: 1
            }]
        }
        
        set loading(state) {
            this.$button.classList.toggle(CN_LOADING, state);
        }

        get cartNotificationsEnabled() {
            return window.global.cartNotificationsEnabled;
        }

        set variantId(id) {
            this.setAttribute(ATTR_VARIANT_ID, id)
        }

    })
})();